<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  mounted() {
    this.renderChart(
      {
        labels: ["Two Wheeler", "Three Wheeler", "Car", "LCV", "Bus", "Truck"],
        datasets: [
          {
            data: [205, 310, 410, 187, 220, 190],
            backgroundColor: [
              "#556ee6",
              "#FF9333",
              "#1FB2B2",
              "#7B1FB2",
              "#9AB21F",
              "#D31198",
            ],
            hoverBackgroundColor: [
              "#556ee6",
              "#FF9333",
              "#1FB2B2",
              "#7B1FB2",
              "#9AB21F",
              "#D31198",
            ],
            hoverBorderColor: "#fff",
            borderWidth: 2,
            radius: "90%",
            innerRadius: "75%",
          },
        ],
      },
      {
        maintainAspectRatio: true,
      }
    );
  },
};
</script>
